export default __webpack_public_path__ + "src/_images/mon_favicon.png";